const productCardInit = () => {
  const mainPattern = document.querySelectorAll('.gg-product-card');
  mainPattern.forEach((module) => {
    const container = module.querySelector('.gg-justify-custom');
    const borders = module.querySelectorAll('.gg-shadow-gradient-border');
    if (container) {
      const items = container.querySelectorAll('.wp-block-column');
      items.forEach((item, index) => {
        item.classList.add('fade-in-up', `delay-${index}`);
      });
      if (items.length > 2) { 
        container.style.setProperty('justify-content', 'start');
        borders.forEach((border, index) => {
          if ((borders.length % 2 === 0 && index >= borders.length - 2) || (borders.length % 2 !== 0 && index === borders.length - 1)) {
            border.style.borderRadius = "24px 24px 0px 0px";
          } else {
            border.style.borderRadius = "24px";
          }
        });
      }
    }
  });
};
productCardInit();